import React from 'react';
import { useMapEvents } from 'react-leaflet'; // <-- Make sure this is here and matches your install
import { POISelectedIdContext } from './POISelectedIdContext';

export default function MapClickPopupCloser() {
  const [selectedPoiId, setSelectedPoiId] = React.useContext(POISelectedIdContext) || [null, () => {}];
  useMapEvents({
    click(e) {
      if (
        e.originalEvent &&
        (e.originalEvent.target.closest('.leaflet-marker-icon') ||
         e.originalEvent.target.closest('.leaflet-popup-content') ||
         e.originalEvent.target.closest('.leaflet-popup'))
      ) {
        return;
      }
      setSelectedPoiId(null);
    }
  });
  return null;
}
